import baseMessages from '@fhnw/messages/base';

function TableSchema(props) {
  const { intl, data } = props;
  const table = data?.table;
  const columnCount = table?.rows?.[0]?.cells?.length || 0;

  // Generate column width and text-wrap fields dynamically
  const columnWidthFields = [];
  const columnWidthProperties = {};

  for (let i = 0; i < columnCount; i++) {
    const widthFieldName = `columnWidth_${i}`;
    const wrapFieldName = `columnWrap_${i}`;

    columnWidthFields.push(widthFieldName, wrapFieldName);

    columnWidthProperties[widthFieldName] = {
      title: intl.formatMessage(baseMessages.columnWidth, {
        columnNumber: i + 1,
      }),
      description: intl.formatMessage(baseMessages.columnWidthDescription),
      type: 'string',
      default: '',
    };

    columnWidthProperties[wrapFieldName] = {
      title: intl.formatMessage(baseMessages.columnTextWrap, {
        columnNumber: i + 1,
      }),
      description: intl.formatMessage(baseMessages.columnTextWrapDescription),
      type: 'boolean',
      default: true,
    };
  }

  return {
    title: intl.formatMessage(baseMessages.table),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['hideHeaders', 'sortable', 'striped', 'caption'],
      },
      ...(columnCount > 0
        ? [
            {
              id: 'columnWidths',
              title: intl.formatMessage(baseMessages.table_tab_column),
              fields: columnWidthFields,
            },
          ]
        : []),
    ],
    properties: {
      hideHeaders: {
        title: intl.formatMessage(baseMessages.hideHeaders),
        type: 'boolean',
      },
      sortable: {
        title: intl.formatMessage(baseMessages.sortable),
        type: 'boolean',
      },
      striped: {
        title: intl.formatMessage(baseMessages.striped),
        type: 'boolean',
      },
      caption: {
        title: intl.formatMessage(baseMessages.table_caption),
        description: intl.formatMessage(baseMessages.table_caption_description),
        type: 'string',
      },
      ...columnWidthProperties,
    },
    required: [],
  };
}

export function TableBlockSchema(props) {
  const { intl } = props;
  return {
    title: intl.formatMessage(baseMessages.table),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['table_field'],
      },
    ],
    properties: {
      table_field: {
        title: intl.formatMessage(baseMessages.table),
        widget: 'object',
        schema: TableSchema(props),
      },
    },

    required: [],
  };
}

export default TableBlockSchema;
